import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { HomeTypesFailure, HomeTypesRequest, HomeTypesSuccess } from './actions';
import { HomeTypesService } from './service';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { getData } from './selectors';

@Injectable()
export class HomeTypesEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly homeTypesService = inject(HomeTypesService);

  homeTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HomeTypesRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.homeTypesService.homeTypes(parameters).pipe(
            map(data => HomeTypesSuccess({ data })),
            catchError(error => of(HomeTypesFailure({ error })))
          );
        }
        return of(HomeTypesSuccess({ data }));
      })
    )
  );

}
